module.exports = __webpack_public_path__ + "home-block-4-overlay@2x-udpMkO7.png";